<svelte:options accessors/>
<script>
    import {network} from '../../stores.js';
    import {validate_int} from '../../validators.js';
    import {createEventDispatcher} from 'svelte';

    const dispatch = createEventDispatcher();
    
    const fetchData = (async () => {
        return await network.fetch_delivery();
    })();
    
    let description = '',
        delivery = '0',
        distance,
        price;
    
    // расчёт стоимости
    const change = (async (e) => {
        let data = await fetchData,
            params = data[delivery];
    
        if (params.step && params.stepPrice) {
            description = [
                'Стоимость ' + (parseFloat(params.price).toFixed(2)) + 'р.',
                'Стоимость шага ' + (parseFloat(params.step).toFixed(2)) + 'км ' + (parseFloat(params.stepPrice).toFixed(2)) + 'р.'
            ].join('<br>');
            
            if (!e || !e.target.matches('[name="distance"]')) {
                distance = parseFloat(params.step).toFixed(2);
            }
            if (!e || !e.target.matches('[name="price"]')) {
                price = parseFloat((+params.price) + (distance - distance % (+params.step)) / (+params.step) * (+params.stepPrice)).toFixed(2);
            }
        } else {
            description = false;
            distance = '';
    
            if (!e.target.matches('[name="price"]')) {
                price = (+params.price).toFixed(2);
            }
        }
        
        let result = {
            idTovar: params.idTovar,
            type: 'доставка',
            name: 'Доставка',
            subname: params.name,
            title: 'Доставка',
            price: {rozn: 0, opt: 0, sebest: 0},
            quantity: 1,
            materials: {},
        };
        
        result.price.rozn = result.price.opt = result.price.sebest = +price > 0 ? price : 0;
    
        dispatch('item', result);
    });

    change();
</script>

{#await fetchData}
    <div class="card-body">
        <div class="text-center">
            <p>Загрузка..</p>
        </div>
    </div>
{:then data}
    <!--<pre>{JSON.stringify(data, null, 4)}</pre>-->
    <div class="card-body" on:keyup={change} on:paste={change} on:change={change}>
        <div class="row">
            <div class="col-12">
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <label class="form-label">Доставка</label>
                        <select class="form-control form-select" bind:value={delivery}>
                            {#each Object.entries(data ?? {}) as [k, item]}
                                <option value="{k}">{item.name}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>
    
            {#if description}
                <div class="col-12">
                    <div class="alert alert-outline-secondary fade show mb-2 text-center" role="alert">
                        {@html description}
                    </div>
                </div>
            {/if}

            {#if data}
                <div class="col-12 col-md-6">
                    <div class="form-group boxed">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Расстояние</label>
                                <input type="number" name="distance" class="form-control" bind:value={distance} min="0" use:validate_int={distance}>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-md-6">
                    <div class="form-group boxed">
                        <div class="form-group boxed">
                            <div class="input-wrapper">
                                <label class="form-label">Стоимость</label>
                                <input type="number" name="price" class="form-control" bind:value={price} min="0" use:validate_int={price}>
                            </div>
                        </div>
                    </div>
                </div>
            {/if}
        </div>
    </div>
{/await}
